import React from "react";
import { useNavigate } from "react-router-dom";

import { RoutesNames } from "../../components/utils/routes";
import CardInfoOption from "../../components/Health/components/cards/CardInfoOption";
import Header from "../../components/header";

import {
  Back,
  ContainerImage,
  ContainerMain,
  Description,
  Image,
  Title,
} from "../../styles/PageStyles/Health/stylesOptionsHealth";
import { ContainerInfo, TextNumbers } from "../../components/Health/components/cards/CardInfoOption/styles";
import useScreenSize from "../../Hooks/useScreenSize";

const OptionsServicesGuide = () => {
  const navigate = useNavigate();
  const { width } = useScreenSize();

  const handleForm = (redirect) => {
    navigate(redirect);
  };

  return (
    <div>
      <Header />
      <ContainerMain>
        <Back onClick={() => handleForm(RoutesNames.home)}>Volver</Back>
        <Title>Guía de Servicios</Title>
        <Description>
          By accessing and placing an order with UXTheme, you confirm that you are in agreement with and bound by the
          terms and conditions
        </Description>
        <ContainerImage>
          <Image src="/Health/imageHealth.png" />
        </ContainerImage>
        <CardInfoOption number="1" press={() => handleForm(RoutesNames.Directory)}>
          <ContainerInfo one>
            <TextNumbers style={width <= 425 ? { width: "70%", textAlign: "center" } : { textAlign: "center" }}>
              Directorio de municipios
            </TextNumbers>
            <TextNumbers>
              Lorem ipsum odor amet, consectetuer adipiscing elit. Sed finibus suspendisse pretium eget erat gravida sit
              euismod metus? Iaculis tellus diam ullamcorper mattis efficitur enim lorem.
            </TextNumbers>
          </ContainerInfo>
        </CardInfoOption>
      </ContainerMain>
    </div>
  );
};

export default OptionsServicesGuide;
